import { createSelector } from '@ngrx/store';
import { getAdminState } from '@appState/reducers/admin.reducer';

export const getSelectedShareholder = createSelector(
  getAdminState,
  state => state.selectedShareholder
);
